import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import {saveNewLeadDataAPI} from './../../API/Caller/LeadAPI';
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
import { errorMesg } from "../Toaster";
//import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Toaster";



const LeadAdd = () =>{

    //const [statelist, setStateList] = useState([]);
    //const [campaignlist, setCampaignList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [txtcampaign, setTxtCampaign] = useState(0);
    const [txtname, setTxtName] = useState(null);
    const [txtemail, setTxtEmail] = useState(null);
    const [txtphone, setTxtPhone] = useState(null);
    const [txtlocation, setTxtLocation] = useState(null);
    const [txtprogram, setTxtProgram] = useState(null);
    const [txtinstitute, setTxtInstitute] = useState(null);
    //const [txtsource, setTxtSource] = useState(null);
    //const navigate = useNavigate();


    useEffect(() => {

        //CampaignListAPI(setCampaignList);

    }, []);

    const handleInputName = (event) =>{
        setTxtName(event.target.value);
    }

    const handleInputEmail = (event) =>{
        setTxtEmail(event.target.value);
    }

    const handleInputPhone = (event) =>{
        setTxtPhone(event.target.value);
    }

    const handleInputLocation = (event) =>{
        setTxtLocation(event.target.value);
    }

    const handleInputProgram = (event) =>{
        setTxtProgram(event.target.value);
    }

    const handleInputInstitute = (event) =>{
        setTxtInstitute(event.target.value);
    }

    

    /*const handleCampaignID = (event) =>{
        setTxtCampaign(event.target.value);
    }*/
    
    const resetUserForm = () =>{

        setTxtCampaign(0);
        setTxtName("");
        setTxtEmail("");
        setTxtPhone("");
        setTxtLocation("");
        setTxtProgram("");
        setTxtInstitute("");
    }

    const handleAddLead = () =>{

        /*if(txtcampaign === "")
        {
            errorMesg("Please select campaign");
            return;
        }
        else*/ 

        if(txtname === "")
        {
            errorMesg("Please enter name");
            return;
        }
        else if(txtemail === "")
        {
            errorMesg("Please enter email");
            return;
        }
        else if(txtphone === "")
        {
            errorMesg("Please enter phone");
            return;
        }
        else if(txtlocation === "")
        {
            errorMesg("Please enter city");
            return;
        }
        
        else
        {
            let params = {
                        "campaignid" : txtcampaign,
                        "name" : txtname,
                        "email" : txtemail,
                        "phone" : txtphone,
                        "location" : txtlocation,
                        "program" : txtprogram,
                        "institute": txtinstitute
                    };
            
            console.log('params======' + JSON.stringify(params));

            saveNewLeadDataAPI(params, setLoading, resetUserForm);
        }
    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper cardhead">
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row">
                        <div className="col">
                            <h3 className="page-title">Add New Lead</h3>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">                        
                        <div className="card">                            
                            <div className="card-body">
                                <form method="post" name="frmaddlead" id="frmaddlead">
                                    {/*<div className="mb-3">
                                        <label className="form-label">Campaign Name</label>
                                        <select className="form-control" name="campaignname" id="campaignname" value={txtcampaign} onChange={handleCampaignID}>
                                            <option value="">Select Campaign</option>
                                            {campaignlist && campaignlist.length > 0 ?
                                                (campaignlist.map(campaign =>
                                                    (
                                                        <option value={campaign.id} key={campaign.id}>{campaign.name}</option>
                                                    )
                                                )

                                                )
                                            :
                                                <></>    
                                            }
                                            
                                        </select>
                                    </div>*/}

                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        <input type="text" className="form-control" name="name" id="name" value={txtname} onChange={handleInputName} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input type="email" className="form-control" name="email" id="email" value={txtemail} onChange={handleInputEmail} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Contact</label>
                                        <input type="text" className="form-control" name="contact" id="contact" value={txtphone} onChange={handleInputPhone} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Location</label>
                                        <input type="text" className="form-control" name="location" id="location" value={txtlocation} onChange={handleInputLocation} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Program</label>
                                        <input type="text" className="form-control" name="program" id="program" value={txtprogram} onChange={handleInputProgram} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Institute</label>
                                        <input type="text" className="form-control" name="institute" id="institute" value={txtinstitute} onChange={handleInputInstitute} />
                                    </div>

                                    <div className="text-end">
                                        <button type="button" className="btn btn-primary"  onClick={handleAddLead}>
                                            {loading ?
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            :
                                                <p>Add Lead</p>
                                            }
                                        </button>
                                    </div>
                                </form>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <ToastContainer />

    </div>
    )
}

export default LeadAdd;